var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'entity', params: { id: _vm.entity.entityId } }}},[_vm._v(_vm._s(_vm.entity.nameFormatted))])}
var staticRenderFns = []

export { render, staticRenderFns }